module.exports = __webpack_public_path__ + "img/16-img0ne.9cc3ac0a.png";